import React from 'react';
import {Box, Grid, IconButton, Typography} from "@mui/material";
import MyCard from "../../../../components/Site/MyCard/MyCard";
import {GetState} from "../../../../redux/reduxhelper";
import {IS_AUTH} from "../../../../redux/action/type.action";
import {useNavigate} from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {getPlanListApi} from "../../../../api/ClientApi";
import {useQuery} from "react-query";
import Loading from "../../../../components/Site/Loading/Loading";


const ProgramsSection = () => {
    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();

    const getPlanList = async () => {
        try {
            const res = await getPlanListApi()
            return (res?.data?.data)
        } catch (e) {
            // log error
        }
    }

    const {
        isLoading,
        data: planList,
    } = useQuery(['plan_list'], getPlanList);

    if (isLoading) return <Loading/>;

    return (
        <Box sx={{
            width: '100vw',
            display: 'flex',
            flexDirection: "column",
            minHeight: '600px',
            alignItems: 'center',
            justifyContent: 'center',

        }}>
            <Grid sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxWidth: '1300px',
                margin: '20px',
            }}>
                <Grid sx={{display: "flex", margin: "auto"}}>
                    <Typography variant={"h3"} sx={{fontWeight: 700, marginBottom: '70px'}}>
                        انتخاب برنامه
                    </Typography>
                </Grid>
                {isAuth && <Box sx={{textAlign: "right", width: '100%'}}>
                    <IconButton sx={{color: "#592EA9", cursor: "pointer"}}
                                onClick={() => navigate('/admin/dashboard/programs')}>
                        <EditOutlinedIcon/>
                    </IconButton>
                </Box>}
                <Grid gap={3} sx={{
                    display: "flex",
                    flexDirection: {md: "row", xs: "column"},
                    justifyContent: "space-between",
                    alignItems: "center",

                }}>

                    {planList?.map((item) => (
                        <MyCard    key={item?.id} title={item?.name} navigateUrl={`/programs/${item?.id}`}
                                content={item?.description}/>
                    ))}

                </Grid>
            </Grid>
        </Box>
    );
};

export default ProgramsSection;
